import Vue from 'vue';
import contactTransformer from './../../transformers/contact';
import find from './show';

// When the request succeeds
const success = (resolve) => {
  find();
  resolve();
};

// When the request fails
const failed = (error, reject) => {
  reject(contactTransformer.fetch(error.response.data));
};

export default (contact) => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.put('/contacts', contact)
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/contact/update.js